<template lang='slm'>
  form.text-left @submit.prevent='formSubmit'
    template v-if='item'
      button.d-none
      .form-group
        label Картинка
        .d-block.text-center
          img.preview :src='"/api/file/" + item.imageId + "?original"'
          small.d-block.mt-1 1920x600
        admin-file-uploader v-model='item.imageId'
      .form-group
        label Квадратная картинка
        .d-block.text-center
          img.preview :src='"/api/file/" + item.squareImageId + "?original"'
          small.d-block.mt-1 550x550
        admin-file-uploader v-model='item.squareImageId'
      .form-group
        label Название
        input.form-control type='text' name='title' v-model='item.title'
      .form-group
        label Спикер
        input.form-control type='text' name='speaker' v-model='item.speaker'
      .form-group
        label Дата
        input.form-control type='datetime-local' name='datetime' v-model='item.datetime'
</template>

<script>
import AdminFileUploader from '@/components/AdminFileUploader';

export default {
  name: 'AdminCarouselImageModalContent',
  components: { AdminFileUploader },
  data() {
    return {
      item: null,
    };
  },
  methods: {
    formSubmit() {
      this.$parent.confirm();
    },
    beforeShow(item) {
      this.item = this.$_removeImmutabitity(item);
      // eslint-disable-next-line no-underscore-dangle
      delete this.item.__typename;
    },
  },
  computed: {
    modalContentData() {
      return this.item;
    },
  },
  mounted() {
    this.$on('beforeShow', this.beforeShow);
  },
};
</script>
